import { render } from "./OnGoingCoursesComponent.vue?vue&type=template&id=1bac3c3d&scoped=true"
import script from "./OnGoingCoursesComponent.vue?vue&type=script&lang=js"
export * from "./OnGoingCoursesComponent.vue?vue&type=script&lang=js"

import "./OnGoingCoursesComponent.vue?vue&type=style&index=0&id=1bac3c3d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bac3c3d"]])

export default __exports__